import { Controller } from "@hotwired/stimulus"

// Narrows a project dropdown to the selected client's projects. The full
// project list is read from a value rather than the DOM so the option pool
// survives TomSelect rewriting the underlying <select>.
export default class extends Controller {
  static targets = ["client", "project"]
  static values = { projects: Array }

  connect() {
    // TomSelect on the child selects initializes after this connect; defer
    // the initial filter until it exists.
    if (this.clientTarget.value) requestAnimationFrame(() => this.filter())
  }

  filter() {
    const tomSelect = this.projectTarget.tomselect
    if (!tomSelect) return

    const clientId = this.clientTarget.value
    const projects = clientId
      ? this.projectsValue.filter((project) => String(project.clientId) === clientId)
      : this.projectsValue

    const selected = tomSelect.getValue()
    tomSelect.clear(true)
    tomSelect.clearOptions()
    tomSelect.addOptions(projects.map((project) => ({ value: String(project.id), text: project.name })))
    if (projects.some((project) => String(project.id) === selected)) {
      tomSelect.setValue(selected, true)
    }
    tomSelect.refreshOptions(false)
  }
}
